import { z } from './utils/zod.js';
import { dataResponse } from './utils/response-templates.js';
import { planCodeSchema, planIntervalSchema } from './pricing-catalogue.js';
export const MCP_SCOPES = ['read', 'write'];
export const mcpScopeSchema = z.enum(MCP_SCOPES);
export const MCP_SCOPE_DESCRIPTIONS = {
    read: 'View your account, plan, documents, signings and contacts',
    write: 'Create and change documents, signing drafts and contacts on your behalf. Signing always stays with you.',
};
export const MCP_ACCESS_REASONS = ['trial', 'subscribed', 'override', 'expired', 'blocked'];
export const mcpAccessReasonSchema = z.enum(MCP_ACCESS_REASONS);
export const mcpAccessDtoSchema = z.object({
    allowed: z.boolean(),
    reason: mcpAccessReasonSchema,
    accessUntil: z.string().datetime().nullable().openapi({ description: 'null = no end date' }),
    upgradeUrl: z.string(),
});
export const mcpAccessStatusDtoSchema = z.object({
    enabled: z.boolean(),
    mcpUrl: z.string(),
    access: mcpAccessDtoSchema.nullable(),
});
export const mcpAccessStatusResponseSchema = dataResponse(mcpAccessStatusDtoSchema);
export const MCP_READINESS_REASONS = ['kyc_missing', 'mcp_access_expired', 'mcp_access_blocked'];
export const mcpReadinessReasonSchema = z.enum(MCP_READINESS_REASONS);
export const mcpAccountDtoSchema = z.object({
    user: z.object({
        id: z.string().uuid(),
        name: z.string(),
        email: z.string(),
        role: z.string(),
    }),
    organization: z.object({
        id: z.string().uuid(),
        name: z.string(),
        planCode: planCodeSchema,
        planInterval: planIntervalSchema.nullable(),
    }),
    mcpAccess: mcpAccessDtoSchema,
    readiness: z.object({
        canStartSignings: z.boolean(),
        reasons: z.array(mcpReadinessReasonSchema),
        fixUrl: z.string().nullable(),
    }),
});
